import React from "react";
import { Link } from "react-router-dom";
import BaseLayout from "../layouts/BaseLayout";

const NotFoundPage: React.FC = () => {
    return (
        <BaseLayout>
            <div className="flex flex-col items-center justify-center min-h-screen">
                <h1 className="text-9xl font-bold text-blue-500">404</h1>
                <p className="text-xl mt-4">Oops! The page you're looking for doesn't exist.</p>
                <Link
                    to="/"
                    className="mt-6 px-6 py-3 bg-blue-500 text-white font-semibold rounded-md shadow hover:bg-blue-600 focus:outline-none focus:ring-2 focus:ring-blue-400 focus:ring-offset-2 transition"
                >
                    Go Back to Home
                </Link>
            </div>
        </BaseLayout>
    );
};

export default NotFoundPage;
